/* ============================================================
   MAWJ — Lander lead form
   Collects the customer's order details and builds a WhatsApp
   message so the chat they send already contains everything.

   Pricing:
     - Base piece ............ 125 AED
     - Second piece .......... +115 AED (10 AED discount)
     - Luxury gift box ....... +25 AED per piece
     - Shipping .............. free

   Contact tracking is handled globally by mawj-contact-tracking.js
   (the submit element is an <a href="wa.me/..."> so the global
   click listener fires Contact once per session).
   ============================================================ */
(function () {
  'use strict';

  var BASE = 125;        // first piece
  var SECOND_ADD = 115;  // second piece (125 - 10 discount)
  var BOX_EACH = 25;     // luxury box, per piece

  function fieldValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function initForm(form) {
    var shapeBtns = form.querySelectorAll('.mwlf-shape');
    var qtyBtns = form.querySelectorAll('.mwlf-qtyOpt');
    var boxInput = form.querySelector('input[name="box"]');
    var totalVal = form.querySelector('.mwlf-totalVal');
    var submit = form.querySelector('.mwlf-submit');
    var phone = form.getAttribute('data-phone') || '971503395366';
    var product = form.getAttribute('data-product') || 'كريستال موج';

    var state = { shape: '', qty: 1, box: false };

    function calcTotal() {
      return BASE + (state.qty === 2 ? SECOND_ADD : 0) + (state.box ? BOX_EACH * state.qty : 0);
    }

    function buildMessage() {
      var lines = [
        'مرحباً، أريد طلب ' + product + ' شامل التوصيل المجاني.',
        '',
        'الاسم: ' + (fieldValue(form, 'name') || '—'),
        'رقم الواتساب: ' + (fieldValue(form, 'phone') || '—'),
        'العنوان داخل الإمارات: ' + (fieldValue(form, 'address') || '—'),
        'الشكل المختار: ' + (state.shape || 'غير محدد'),
        'العدد: ' + (state.qty === 2 ? 'قطعتين' : 'قطعة واحدة'),
        'علبة هدية فاخرة: ' + (state.box ? 'نعم' : 'لا'),
        'الملاحظات: ' + (fieldValue(form, 'notes') || 'لا يوجد'),
        'الإجمالي: ' + calcTotal() + ' درهم',
        '',
        'أريد تأكيد الطلب واستلام الصورة للمعاينة.'
      ];
      return lines.join('\n');
    }

    function refresh() {
      if (totalVal) totalVal.textContent = calcTotal();
      if (submit) submit.setAttribute('href', 'https://wa.me/' + phone + '?text=' + encodeURIComponent(buildMessage()));
    }

    shapeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        shapeBtns.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        state.shape = b.getAttribute('data-shape') || '';
        refresh();
      });
    });

    qtyBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        qtyBtns.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        state.qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        refresh();
      });
    });

    if (boxInput) {
      boxInput.addEventListener('change', function () {
        state.box = boxInput.checked;
        refresh();
      });
    }

    form.querySelectorAll('input[type="text"], input[type="tel"]').forEach(function (i) {
      i.addEventListener('input', refresh);
    });

    refresh();
  }

  /* Every other WhatsApp button (top / end / float / side / data-wa="1")
     now scrolls to the form instead of opening WhatsApp, so all customers
     go through it. Only the form's own submit (data-wa="form") opens chat. */
  function initScrollers(form) {
    var triggers = document.querySelectorAll('[data-wa]:not([data-wa="form"])');
    triggers.forEach(function (t) {
      t.setAttribute('href', '#mwlfForm');
      t.removeAttribute('target');
      t.addEventListener('click', function (e) {
        e.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = form.querySelector('input[name="name"]');
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }, 400);
      });
    });
  }

  function init() {
    var form = document.querySelector('.mwlf');
    if (!form) return;
    initForm(form);
    initScrollers(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
